// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__22eCV","containerItemsCenter":"Skeleton_containerItemsCenter__2DE67"};